export const ultra_1 = {
    'images': [],
    'mainFeatures': [
        'Nano Graphite Coating with Premium Nature Rubber.',
        'Patented Multi-functional Mounting Base & Adapters.',
    ],
    'material': [
        'Rubber: Premium Nature Rubber.',
        'Steel: SGCC, Electrostatic Powder Coating.',
        'Plastic: Spacer & Adapter: PC+PBT',
        'Stainless Steel Backing: SUS304ES',
    ],
    'featureIcons': ["02", "03", "08", "10"],
    'otherFeatures': ["01", "02"],
    'specification': [
        { "inch": "8", "mm": "200", "claw": "4", "width": "6", "thickness": "1" },
        { "inch": "10", "mm": "250", "claw": "4", "width": "6", "thickness": "1" },
        { "inch": "11", "mm": "280", "claw": "4", "width": "6", "thickness": "1" },
        { "inch": "12", "mm": "300", "claw": "4", "width": "6", "thickness": "1" },
        { "inch": "14", "mm": "350", "claw": "4", "width": "6", "thickness": "1" },
        { "inch": "16", "mm": "400", "claw": "4", "width": "6", "thickness": "1" }
    ],
    'adapters': ["ra", "rb", "rc", "rd", "rd+", "re+rec", "rg"]
}